import { createContext, useContext, useEffect, useState } from "react";
import AuthContext from "./AuthContext";
import useAxios from "../Utils/useAxios";
import { toast } from "react-toastify";
import { timeToast } from "../Constant";

const RoleContext = createContext();

export default RoleContext;

export const RoleProvider = ({ children }) => {
  const { authTokens } = useContext(AuthContext);
  const [permissionList, setPermissionList] = useState([]);
  const [group, setGroup] = useState([]);

  const axiosInstance = useAxios();

  useEffect(() => {
    if (authTokens) {
      getPermission();
    }
  }, [authTokens]);

  const getPermission = async () => {
    const response = await axiosInstance
      .get("auth/permission/")
      .catch((error) => {
        console.error(error);
        toast.error(`GET Cuti ${error.message}`, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: timeToast,
        });
        throw error;
      });
    setPermissionList(response.data.permissions);
    setGroup(response.data.groups);
  };

  const checkPermission = (permission) => {
    const result = permissionList.some((perm) => perm.codename === permission);
    return result;
  };
  const checkGroup = (grp) => {
    const result = group.some((item) => item.name === grp);
    return result;
  };

  const contextData = {
    checkPermission: checkPermission,
    checkGroup: checkGroup,
  };

  return (
    <RoleContext.Provider value={contextData}>{children}</RoleContext.Provider>
  );
};
